import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import dotIcon from "@icons/ic-dot-navy-blue.svg";
import DocumentPreview from "../../../../Document/DocumentPreview/DocumentPreview";

import {
  DisputeOuter,
  GridRow,
  GridSubItem,
  DocumentRow,
  DocumentName,
} from "../../DisputeView.styled";
import "../../DsiputeView.scss";

const DisputeContent = (props) => {
  const { t, data } = props;
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  return (
    <>
      <DisputeOuter>
        <GridRow
          column="auto 1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="5px 10px 0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem color="#0A4986" fontWeight="700" fontSize="16px">
            {t("DISPUTES_RESPONSIBLE")} :
          </GridSubItem>
          <GridSubItem color="#474747" fontWeight="400" fontSize="16px">
            {data.type === 4 && t("DISPUTE_RESPONSIBILITY_HESUS")}
            {data.type !== 4 && data.responsible.name}
          </GridSubItem>
        </GridRow>
        <GridRow
          column="auto 1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem color="#0A4986" fontWeight="700" fontSize="16px">
            {t("DISPUTES_FEE")} :
          </GridSubItem>
          <GridSubItem color="#474747" fontWeight="400" fontSize="16px">
            {data.fees ? data.fees : " - "}
          </GridSubItem>
        </GridRow>
        <GridRow
          column="1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem color="#0A4986" fontWeight="700" fontSize="16px">
            {t("DISPUTES_DETAILS")} :
          </GridSubItem>
        </GridRow>
        <GridRow
          column="1fr"
          marginBottom="0px"
          marginTop="0px"
          padding="0px 10px"
          gridGap=".25rem"
        >
          <GridSubItem color="#474747" fontWeight="400" fontSize="16px">
            <div
              dangerouslySetInnerHTML={{
                __html: data.details,
              }}
            ></div>
            {data?.documents?.length !== "" &&
              data?.documents?.map((document, documentIndex) => {
                return (
                  <DocumentRow
                    key={`dispute-list-document-${data.id}${document.id}${documentIndex}`}
                  >
                    <GridRow gap="0rem" column="1fr auto">
                      <DocumentName
                        onClick={() => openPreview(document)}
                        className="dispute-view__document-link "
                      >
                        <Image
                          className="deleteImage"
                          src={dotIcon}
                          alt="delete"
                          styles={{ marginRight: "6px" }}
                        />
                        {document?.fileName}
                      </DocumentName>
                    </GridRow>
                  </DocumentRow>
                );
              })}
          </GridSubItem>
        </GridRow>
      </DisputeOuter>
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

DisputeContent.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(DisputeContent);
